import React, { useState, useRef, useEffect } from 'react'

export default ({
    tabs,
    showCount
}) => {
    const [activeTabIndex, setActiveTabIndex] = useState(0)
    const [isCompact, setIsCompact] = useState((() => {
        if(window.innerWidth < 1560 && tabs && tabs.length > 7){
            return true
        }

        return false
    })())

    const changeTab = index => {
        setActiveTabIndex(index)
    }

    return (
        <div className={`tab-content ${ isCompact ? 'compact' : ''}`}>
            <ul className={'tabs clear'}>
                { tabs.map(({
                    id,
                    name,
                    props
                }, index) => {
                    let tabName = name

                    if(showCount && props && props.tasks){
                        tabName += ` (${ props.tasks.length })`
                    }

                    return (
                        <li className={index === activeTabIndex ? 'active' : ''} key={id}>
                            <button onClick={() => changeTab(index)}>
                                { tabName } 
                            </button>
                        </li>
                    )
                })}
            </ul>
            <div className={'inner'}>
                <div>
                    { tabs.map(({ 
                        Component,
                        props
                    }, index) => {
                        if(activeTabIndex !== index){
                            return null
                        }

                        return (
                            <Component 
                                key={index}
                                {...props}
                            />
                        )
                    })}
                </div>
            </div>
        </div>
    )
}